<template>
  <selector-layout>
    <div class="l-main-layout">
      <div class="l-main-layout__sidebar">
        <NavIcons />
      </div>

      <div class="l-main-layout__main" :key="categoryId">

        <section class="actions">
          <div class="picker">
            <span>Colour</span>
            <i class="picker-option picker-option--black" :class="colour == 'black' ? 'active' : ''" @click="colour = 'black'"></i>
            <i class="picker-option picker-option--blue" :class="colour == 'blue' ? 'active' : ''" @click="colour = 'blue'"></i>
            <i class="picker-option picker-option--pink" :class="colour == 'pink' ? 'active' : ''" @click="colour = 'pink'"></i>
            <i class="picker-option picker-option--white" :class="colour == 'white' ? 'active' : ''" @click="colour = 'white'"></i>
          </div>
        </section>

        <section v-if="icons && icons.entries">
          <div class="icons">
            <div 
              v-for="icon in icons.entries" :key="icon.id"
              class="icon" 
              :class="selected && selected.id == icon.id ? 'selected' : selected ? 'not-selected' : ''" 
            >
              <div class="svg_icon" :id="icon.id + '_black'" @click="toggle(icon)" v-show="colour == 'black'"><svg-icon :icon="icon.imageData" setColour="#16162D"></svg-icon></div>
              <div class="svg_icon" :id="icon.id + '_blue'" @click="toggle(icon)" v-show="colour == 'blue'"><svg-icon :icon="icon.imageData" setColour="#3256FF"></svg-icon></div>
              <div class="svg_icon" :id="icon.id + '_pink'" @click="toggle(icon)" v-show="colour == 'pink'"><svg-icon :icon="icon.imageData" setColour="#DFA9FF"></svg-icon></div>
              <div class="svg_icon" :id="icon.id + '_white'" @click="toggle(icon)" v-show="colour == 'white'"><svg-icon :icon="icon.imageData" setColour="#FFFFFF"></svg-icon></div>
              <span class="icon__name">{{icon.name}}</span>
            </div>
          </div>

          <infinite-loading v-if="infiniteLoadReady" @infinite="infiniteHandler">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </section>


        <div class="download-bar-container" :class="selected ? 'is-visible' : ''">
          <div class="download-bar">
            <div>
              <span class="items" v-if="selected">'{{ selected.name }}' selected</span>
            </div>
            <button class="button button--white" @click="download">Confirm</button>
          </div>
        </div>

      </div>

    </div>
  </selector-layout>
</template>

<script>
import NavIcons from '../../components/NavIcons';
import InfiniteLoading from 'vue-infinite-loading';
import SvgIcon from '../../components/SvgIcon.vue';
import { store } from '../../utils/store';
import IconsQuery from '../../graphql/icons';

export default {
  components: {
    NavIcons,
    InfiniteLoading,
    SvgIcon,
  },

  props: ["categoryId"],

  data() {
    return {
      page: 1,
      pageSize: 24,
      sortField: 'created_at',
      sortOrder: 'desc',
      search: '',
      left: 0,
      top: 0,
      display: false,
      id: null,
      colour: "black",
      infiniteLoadReady: true,
      selected: null,
    }
  },

  computed: {
    store() {
      return store;
    }
  },

  apollo: {
    icons: {
      query: IconsQuery,
      variables: {
        page: 1,
        pageSize: 24,
        sortField: 'created_at',
        sortOrder: 'desc',
        search: '',
        categoryId: 0
      },
    }
  },

  created () {
    this.reset()
  },

  watch: {
    '$route': 'reset'
  },

  methods: {
    reset() {
      this.page = 1;
      this.$apollo.queries.icons.setVariables({
        page: 1,
        pageSize: 24,
        sortField: 'created_at',
        sortOrder: 'desc',
        search: '',
        categoryId: parseInt(this.categoryId),
      })
      this.$apollo.queries.icons.refetch().then(() => {
        this.infiniteLoadReady = false
        this.$nextTick(() => {
          this.infiniteLoadReady = true
        })
      });
    },

    infiniteHandler($state) {
      if (this.page >= this.icons.pagesCount) {
        $state.complete();
        return
      }
      this.page += 1
      let vm = this
      this.$apollo.queries.icons.fetchMore({
        // New variables
        variables: {
          page: vm.page,
          pageSize: vm.pageSize,
          sortField: vm.sortField,
          sortOrder: vm.sortOrder,
          search: vm.search,
          categoryId: parseInt(vm.categoryId),
        },
        // Transform the previous result with new data
        updateQuery: (previousResult, { fetchMoreResult }) => {
          $state.loaded();

          return {
            icons: {
              __typename: "IconPage",
              entries: [...previousResult.icons.entries, ...fetchMoreResult.icons.entries],
              entriesCount: fetchMoreResult.icons.entriesCount,
              pageSize: fetchMoreResult.icons.pageSize,
              pagesCount: fetchMoreResult.icons.pagesCount,
              currentPage: fetchMoreResult.icons.currentPage,
            },
          }
        },
      })
    },
    toggle(icon) {
      if (this.selected && this.selected.id == icon.id) {
        this.selected = null
      } else {
        this.selected = icon
      }
    },
    download() {
      if(this.selected) {
        const svgContent = document.getElementById(this.selected.id + "_" + this.colour).getElementsByTagName("svg")[0].outerHTML;
        const filename = `${this.selected.name} - ${this.colour.charAt(0).toUpperCase() + this.colour.substring(1)}.svg`

        const image = {
          data: svgContent,
          name: filename,
        }
        parent.postMessage({'event': 'file-upload', 'file': image}, '*');      
      } 
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '../../styles/mixins';

  @mixin iconBuilder($width, $height, $file) {
    width: #{$width}px;
    height: #{$height}px;
    background-image: url('../../assets/images/icons/' + $file);
  }

  .actions {
    display: flex;
    justify-content: space-between;
    padding: 87px;
    padding-bottom: 0px;
    border-bottom: 0px;

    .picker {
      display:flex;
      align-items: center;

      span {
        margin-right: 12px;
        font-size: 14px;
        font-family: var(--f-bold);
        color: black;
      }
      .picker-option {
        margin-left: 12px;
        padding-bottom: 35px;
        border-bottom: 2px solid #f7f8f9;
        cursor: pointer;

        display: inline-block;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        &--black {
          @include iconBuilder(22, 22, 'icon--black.svg');
        }

        &--blue {
          @include iconBuilder(22, 22, 'icon--blue.svg');
        }

        &--pink {
          @include iconBuilder(22, 22, 'icon--pink.svg');
        }

        &--white {
          @include iconBuilder(22, 22, 'icon--white.svg');
        }

        &.active {
          border-bottom: 2px solid #DFA9FF;
        }
      }
    }

  }

  .icons {
    display: grid;
    justify-content: start;
    grid-column-gap: 16px;
    grid-row-gap: 50px;

    grid-template-columns: repeat( auto-fill, 144px );

  }

  .icon {
    position: relative;

    &.not-selected:hover {

    }

    &__name {
      font-family: var(--f-semi);
        font-size: 11px;
        opacity: 0.4;
        margin-top: 13px;
    }

    .svg_icon {
      cursor: pointer;
      opacity: 1;
      transition: opacity .3s;
    }

    &.selected {
      .svg_icon {
        outline: 1px solid var(--text-pink);
        opacity: 1;
      }
    }

    &.not-selected {
      .svg_icon {
        border: none;
        opacity: 0.5;
      }

      &:hover {
        .svg_icon {
          opacity: 1;
        }
      }
    }
  }

  .download-bar-container {
    padding-left: 300px;
    @include bp(880px) {
      padding-left: 200px;
    }
    @include bp(680px) {
      padding-left: 0px;
    }
    position: fixed;
    bottom: 0;
    left: 0;
    right:0;
    transform: translateY(100%);
    transition: transform .4s;

    &.is-visible {
      transform: translateY(0);
    }

    .download-bar {
      width: 100%;
      background: #3256FF;
      padding: 17px 30px;
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .items {
        font-family: var(--f-bold);
        font-size: 14px;
        margin-right: 20px;
      }

    }
  }

  input[type="file"]{
    position: absolute;
    top: -9000px;
    left: -9000px;
  }

  .delete {
    opacity: 0;
    transition: opacity .3s;
    position: absolute;
    top: 0%;
    left: 100%;
    transform: translate(-100%, 0%);
    width: 44px;
    height: 44px;
    background-color: var(--white);
    background-image: url('../../assets/images/icons/icon--cross.svg');
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 9px;
    cursor: pointer;
    z-index: 950;
  }
</style>
